// Packages
import styled from 'styled-components'

export const StyledContactPageContent = styled.div``
